// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-container,
.popup-inline {
  display: grid;
  gap: 0.55rem;
}

.popup-container {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 2147483647;
  pointer-events: none;
}

.popup-inline {
  width: 100%;
}

.notification-list {
  display: grid;
  gap: 0.35rem;
}

.notification-list__item {
  padding: 0.65rem 0.75rem;
  border: 1px solid rgba(var(--ion-text-color-rgb, 15, 23, 42), 0.08);
  border-left: 3px solid transparent;
  border-radius: 12px;
  background: var(--ion-card-background, var(--ion-background-color, #fff));
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.12);
}

.notification-list__item--success {
  border-left-color: var(--ion-color-success);
}

.notification-list__item--danger {
  border-left-color: var(--ion-color-danger);
}

.notification-list__item--warning {
  border-left-color: var(--ion-color-warning);
}

.notification-list__meta {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.notification-list__meta strong {
  color: var(--ion-text-color);
  font-size: 0.78rem;
  font-weight: 700;
}

.notification-list__meta small {
  color: rgba(var(--ion-text-color-rgb, 15, 23, 42), 0.58);
  font-size: 0.68rem;
}

.notification-list__item p {
  margin: 0.35rem 0 0;
  color: var(--ion-text-color);
  font-size: 0.82rem;
  line-height: 1.35;
}

.notification-list__item--interactive,
.notification-card--interactive {
  cursor: pointer;
}

.notification-list__item--interactive:focus-visible,
.notification-card--interactive:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}

.notification-card {
  width: min(22rem, 100vw - 2rem);
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.35);
  pointer-events: auto;
}

.popup-inline .notification-card {
  width: 100%;
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.18);
}

.notification-list__empty {
  padding: 0.85rem 1rem;
  border: 1px dashed rgba(var(--ion-text-color-rgb, 15, 23, 42), 0.28);
  border-radius: 14px;
  background: rgba(var(--ion-text-color-rgb, 15, 23, 42), 0.1);
  color: rgba(var(--ion-text-color-rgb, 15, 23, 42), 0.9);
  font-size: 0.9rem;
  font-weight: 500;
  text-align: center;
}

@media (max-width: 640px) {
  .popup-container {
    left: 1rem;
    right: 1rem;
  }
  .notification-card {
    width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/_components/header/centro-notifiche-popup/centro-notifiche-popup.component.scss"],"names":[],"mappings":"AAAA;;EAEE,aAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;AACF;;AAEA;EACE,wBAAA;EACA,mEAAA;EACA,kCAAA;EACA,mBAAA;EACA,yEAAA;EACA,6CAAA;AACF;;AAEA;EACE,2CAAA;AACF;;AAEA;EACE,0CAAA;AACF;;AAEA;EACE,2CAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,4BAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,wDAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;EACA,4BAAA;EACA,kBAAA;EACA,iBAAA;AACF;;AAEA;;EAEE,eAAA;AACF;;AAEA;;EAEE,2CAAA;EACA,mBAAA;AACF;;AAEA;EACE,+BAAA;EACA,8CAAA;EACA,oBAAA;AACF;;AAEA;EACE,WAAA;EACA,8CAAA;AACF;;AAEA;EACE,qBAAA;EACA,oEAAA;EACA,mBAAA;EACA,4DAAA;EACA,uDAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE;IACE,UAAA;IACA,WAAA;EACF;EAEA;IACE,WAAA;EAAF;AACF","sourcesContent":[".popup-container,\n.popup-inline {\n  display: grid;\n  gap: 0.55rem;\n}\n\n.popup-container {\n  position: fixed;\n  top: 1rem;\n  right: 1rem;\n  z-index: 2147483647;\n  pointer-events: none;\n}\n\n.popup-inline {\n  width: 100%;\n}\n\n.notification-list {\n  display: grid;\n  gap: 0.35rem;\n}\n\n.notification-list__item {\n  padding: 0.65rem 0.75rem;\n  border: 1px solid rgba(var(--ion-text-color-rgb, 15, 23, 42), 0.08);\n  border-left: 3px solid transparent;\n  border-radius: 12px;\n  background: var(--ion-card-background, var(--ion-background-color, #fff));\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.12);\n}\n\n.notification-list__item--success {\n  border-left-color: var(--ion-color-success);\n}\n\n.notification-list__item--danger {\n  border-left-color: var(--ion-color-danger);\n}\n\n.notification-list__item--warning {\n  border-left-color: var(--ion-color-warning);\n}\n\n.notification-list__meta {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.notification-list__meta strong {\n  color: var(--ion-text-color);\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n\n.notification-list__meta small {\n  color: rgba(var(--ion-text-color-rgb, 15, 23, 42), 0.58);\n  font-size: 0.68rem;\n}\n\n.notification-list__item p {\n  margin: 0.35rem 0 0;\n  color: var(--ion-text-color);\n  font-size: 0.82rem;\n  line-height: 1.35;\n}\n\n.notification-list__item--interactive,\n.notification-card--interactive {\n  cursor: pointer;\n}\n\n.notification-list__item--interactive:focus-visible,\n.notification-card--interactive:focus-visible {\n  outline: 2px solid var(--ion-color-primary);\n  outline-offset: 2px;\n}\n\n.notification-card {\n  width: min(22rem, calc(100vw - 2rem));\n  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.35);\n  pointer-events: auto;\n}\n\n.popup-inline .notification-card {\n  width: 100%;\n  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.18);\n}\n\n.notification-list__empty {\n  padding: 0.85rem 1rem;\n  border: 1px dashed rgba(var(--ion-text-color-rgb, 15, 23, 42), 0.28);\n  border-radius: 14px;\n  background: rgba(var(--ion-text-color-rgb, 15, 23, 42), 0.1);\n  color: rgba(var(--ion-text-color-rgb, 15, 23, 42), 0.9);\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-align: center;\n}\n\n@media (max-width: 640px) {\n  .popup-container {\n    left: 1rem;\n    right: 1rem;\n  }\n\n  .notification-card {\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
